export enum PagePath {
  home = '/',
  /** 通用错误页（如回调/处理失败落地） */
  handleError = '/handle/error',
  account = '/account',
  contactUs = '/contact-us',
  /** 自动提交落地页：无主布局、免鉴权 */
  autoRequest = '/auto-request',
  demo = '/demo',
  chat = '/chat/:sessionId',
  supplierDetail = '/supplier-detail/:contactId',
  supplier = '/supplier-detail',
  inquiries = '/inquiries',
  /** Agent 进度页面（替代旧 contact-progress；旧实现保留作参考） */
  agentProgress = '/agent-progress/:inquiryId',
  testImagePreview = '/test/image-preview',
  testInquiryDialog = '/test/inquiry-dialog',
  testAuthContent = '/test/auth-content',
  // TODO: 测试用，待删除
  testCountryFlag = '/test/country-flag',
  reports = '/reports',
  /** Component preview directory (dev/test only) */
  preview = '/preview',
  previewDetail = '/preview/*',
}
